import { defineComponent, onMounted, toRefs } from "@vue/composition-api";
import SignUp from "@Client/@Modules/application-widget/welcome/sign-up.vue";
import { parseGenericLocale } from "@Shared/@Utils/utils";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "WelcomeContainer",
  components: {
    SignUp
  },
  props: {
    referrerId: {
      type: String,
      default: ""
    },
    locale: {
      type: String,
      default: undefined
    }
  },
  setup(props) {
    const {
      locale: localeFromParams
    } = toRefs(props);
    const {
      locale
    } = useI18n();
    const setLocaleFromProps = () => {
      if (localeFromParams.value) {
        locale.value = parseGenericLocale(localeFromParams.value);
      }
    };
    onMounted(() => {
      setLocaleFromProps();
    });
  }
});